export default __webpack_public_path__ + "static/media/FOTOS_DISCO_12.b4e5273f.jpg";